import { GroupContext } from 'context/Group';
import { ScommesseTableTitle } from 'components/scommesseTable/scommesseTableTitle';
import { SportScommesseRenderConditional } from 'features/sport/components/sportScommesseRenderConditional';
import classNames from 'classnames';
import styles from './ScommessaTipoGroup.module.scss';
import { useGroup, useIsAvvenimento } from 'features/sport/hooks';

export type ScommessaTipoGroupProps = {
  avvenimentoKey: string;
  isTooltipClicked?: boolean;
  scommessaGroupKey: string;
  isVisualizzazioneEstesa: boolean;
  setIsTooltipClicked?: React.Dispatch<React.SetStateAction<boolean>>;
  className?: string;
};

export const ScommessaTipoGroup = ({
  className,
  avvenimentoKey,
  isTooltipClicked,
  scommessaGroupKey,
  isVisualizzazioneEstesa,
  setIsTooltipClicked,
}: ScommessaTipoGroupProps) => {
  if (!scommessaGroupKey.startsWith('group-')) {
    throw new Error(`This scommessa ${scommessaGroupKey} isn't a group`);
  }
  const isAvvenimento = useIsAvvenimento();
  const { toolTip, toolTipTrKey, descrizione, descrizioneTrKey } = useGroup(scommessaGroupKey) ?? {};
  const tipoScommessaId = scommessaGroupKey.replaceAll('group-', '').split('_') ?? [];
  const scommessaKeyList = tipoScommessaId.map((key) => `${avvenimentoKey}-${key}`);

  return (
    <GroupContext.Provider value={{ avvenimentoKey, scommessaGroupKey }}>
      <div key={scommessaGroupKey} className={classNames(styles.groupContainer, className)}>
        {descrizione && (
          <ScommesseTableTitle
            isEstesa={isVisualizzazioneEstesa}
            labelDx={descrizione}
            tooltipText={toolTip}
            labelDxTrKey={descrizioneTrKey}
            tooltipTextTrKey={toolTipTrKey}
            isTooltipClicked={isTooltipClicked}
            setIsTooltipClicked={setIsTooltipClicked}
          />
        )}
        <div className={styles.scommesseContainer}>
          {scommessaKeyList.map((key, index) => {
            return (
              <SportScommesseRenderConditional
                key={`${key}_${index}`}
                length={scommessaKeyList.length}
                isEstesa={isVisualizzazioneEstesa}
                forceShow
                hasHeader
                scommessaKey={key}
                containerClassName={classNames(styles.block, { [styles.fullWidth]: isAvvenimento })}
              />
            );
          })}
        </div>
      </div>
    </GroupContext.Provider>
  );
};
